import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ContentExpand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }
  handleExpand = (e) => {
    e.preventDefault();
    this.setState({ isExpanded: true });
  }
  render() {
    if (this.props.expandable) {
      if (!this.state.isExpanded) {
        return (
          <div>
            <button
              className="a-button-blue text_expand_single"
              onClick={this.handleExpand}
              title="View more"
              style={{ width: this.props.width }}
            >
              {this.props.shortText}
            </button>
          </div>
        );
      }
      return (
        <div className="text_expand" style={{ width: this.props.width }}>
          {this.props.fullContent}
        </div>
      );
    }
    return (
      <div className="text_expand" style={{ width: this.props.width }}>
        {this.props.shortText}
      </div>
    );
  }
}

ContentExpand.propTypes = {
  shortText: PropTypes.node.isRequired,
  fullContent: PropTypes.node.isRequired,
  expandable: PropTypes.bool,
  width: PropTypes.string.isRequired,
};

export default ContentExpand;



// WEBPACK FOOTER //
// ./src/components/ContentExpand.jsx